/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserList } from '../../models/user-list';

export interface SearchUsers$Any$Params {

/**
 * The search text to filter API
 */
  search?: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
  
    /**
     * Body for search contacts
     */
    body?: any
}

export function searchUsers$Any(http: HttpClient, rootUrl: string, params?: SearchUsers$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<UserList>> {
  const rb = new RequestBuilder(rootUrl, searchUsers$Any.PATH, 'post');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserList>;
    })
  );
}

searchUsers$Any.PATH = '/users/search';
